import { render, staticRenderFns } from "./TurnToYimin.vue?vue&type=template&id=65a743fe&scoped=true"
import script from "./TurnToYimin.vue?vue&type=script&lang=js"
export * from "./TurnToYimin.vue?vue&type=script&lang=js"
import style0 from "./TurnToYimin.vue?vue&type=style&index=0&id=65a743fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a743fe",
  null
  
)

export default component.exports